import { render } from "@/components/organisms/individualDiagCodePolling/IndividualDiagCodePolling.html?vue&type=template&id=9387e634&external"
import script from "@/components/pages/specialFeature/spDiagCode/SpDiagCode.js?vue&type=script&lang=js&external"
export * from "@/components/pages/specialFeature/spDiagCode/SpDiagCode.js?vue&type=script&lang=js&external"

import "@/components/organisms/individualDiagCodePolling/IndividualDiagCodePolling.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__